import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/console/$orgId/configuration/vendor-management/suppliers/list',
            params,
            replace: true,
        });
    },
});
